import { render, staticRenderFns } from "./_UnitRenovationsBlock.vue?vue&type=template&id=c23f5fe0&"
import script from "./_UnitRenovationsBlock.vue?vue&type=script&lang=js&"
export * from "./_UnitRenovationsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports